<template>
    <div class="wb-room-size-input-container-anchor"
         :style="{'top': top + 'px', 'left': left + 'px'}">
        <div class="wb-room-size-input-container">
            <div class="wb-room-size-label">
                {{text}}
            </div>
            <input type="number" class="wb-room-size-input"
                   v-model="getRoomSize"
                   :class="{'wb-danger-input': value > 10000 || value < 450}"
                   @change="setValueHandler($event.target.value)" :title="'700 ... 10000'" ref="input">
        </div>
    </div>
</template>

<script>
import { useConfigurationStore } from '@/Store/storeConfiguration';

export default {
    name: 'OverlayRoomSizeInput',
    props: [
        'top',
        'left',
        'text',
        'valueProp',
        'paramName',
    ],
    data() {
        return {
            value: null,
        };
    },
    setup() {
        const storeConfiguration = useConfigurationStore();
        return {
            storeConfiguration,
        };
    },
    mounted() {
        if(this.valueProp) {
            this.value = this.valueProp.toFixed(0);
        }
    },
    computed: {
      getRoomSize() {
        return (this.storeConfiguration.getRoomParamByName(this.paramName)*1000).toFixed();
      },
    },
    methods: {
        setValueHandler(value) {
          this.value=value;
            if (value > 10000 || value < 450) {
                return;
            }
            this.storeConfiguration.setRoomParamByName(this.paramName, +value/1000);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/common.scss";
@import "CSS/colors.scss";
@import "CSS/fonts.scss";

.wb-room-size-input-container-anchor {
    @include wb-c-flex-center;
    height: 0;
    width: 0;
    position: absolute;
    z-index: 200;
}

.wb-room-size-input-container {
    display: grid;
    grid-template-rows: max-content max-content;
    grid-row-gap: 8px;
}

.wb-room-size-label {
    @include font-t1;
    color: $white;
}

.wb-room-size-input {
    padding: 0 16px 0 16px;
    height: 40px;
    vertical-align: center;
    box-sizing: border-box;
    outline: none;
    border: none;
    color: $darkBlue;
    background-color: $white;
    border-radius: 4px;
    width: 90px;
    -moz-appearance: textfield;
    @include font-h1;
}

.wb-danger-input {
    background-color: $dangerField;
}

.wb-room-size-input::-webkit-outer-spin-button,
.wb-room-size-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

</style>
